module.exports = __webpack_public_path__ + "img/img-01.2b2be1e6.jpg";